import { IntlShape } from 'react-intl'
import { create, enforce, test } from 'vest'
import { type BuyAndWinGift, GiftKeys } from '../../../../../../../typings'
import messages from './messages'

export function validationSuite(intl: IntlShape) {
  return create(({ maxQuantity, items }: BuyAndWinGift) => {
    const { $t } = intl
    const { validation } = messages

    test(GiftKeys.maxQuantity, $t(validation.greaterThan, { value: 0 }), () => {
      enforce(maxQuantity).greaterThan(0)
    })
    test(GiftKeys.items, $t(validation.required), () => {
      enforce(items.length).greaterThan(0)
    })
  })
}
